<!--
 * @Title: 标题
 * @Description: 描述供应链
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:14
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-11-01 00:27:01
 * @FilePath: \vue-privilege-routing\src\pages\system\system-config\business-data\goods-data-sku\index.vue
-->
<template>
  <div>
     模块树管理
  </div>
</template>

<script>
export default {
  data() {
      return {}
  }
}
</script>
